import React from 'react'
import './styles.css';

const LightBlueButton = ({title}) => (
  <div className="LightBlueButton">
    {title}
  </div>
)

export default LightBlueButton;